var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6483 2.0479L8.84843 8.84533C8.38023 9.31392 7.61977 9.31392 7.15157 8.84533L0.351747 2.0479C-0.117249 1.57931 -0.117249 0.820041 0.351747 0.351446C0.820342 -0.117149 1.57961 -0.117149 2.0486 0.351446L8 6.30084L13.9514 0.351446C14.42 -0.117149 15.1801 -0.117149 15.6483 0.351446C16.1172 0.820041 16.1172 1.57931 15.6483 2.0479Z",
    fill: "#231F20",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.c3d21c4aa184cab2d43478abae6e2553.svg";
export { ForwardRef as ReactComponent };